import React from 'react';

interface Props {
    customerName: string;
    ibanLast5: string;
}

export default function ConfirmScreen({ customerName, ibanLast5 }: Props) {
    return (
        <div className="bank-card bank-confirm">
            <h1>Grazie{customerName ? `, ${customerName}` : ''}!</h1>
            <p>I tuoi dati bancari sono stati salvati. L'IBAN registrato termina con <code>{ibanLast5}</code>.</p>
            <hr />
            <h2>Thank you{customerName ? `, ${customerName}` : ''}!</h2>
            <p>Your bank details have been saved. The registered IBAN ends in <code>{ibanLast5}</code>.</p>
        </div>
    );
}
